import React from "react";
import { connect } from 'react-redux'

import {  Card,  Col
  } from "reactstrap";
import CardBody from "reactstrap/lib/CardBody";
import { StandardList } from './StandardList';


var viewActions = require ('store/view.actions');
var setupService = require ('../api');
var personasService = require ('../../personas/api');

class NewProfileImages extends React.Component {

    componentDidMount() {
        setupService.getNewProfilePhotos( this.props.token  )
        .then( json => {
            this.setState( { newProfilePhotos: json } );
        } )
    }
  
    constructor(props) {
      super(props);
      this.state = {
        newProfilePhotos : []
      }
  
   }


    validate=  ( log  ) => {
        setupService.updateAllTags ( this.props.token , log.persona_id, 'NEW_PROFILE_IMAGE', 'V' );
        this.setState( { newProfilePhotos: this.state.newProfilePhotos.filter( (photo) => photo.persona_id !== log.persona_id ) } );
        viewActions.notification({message:'La foto fue validada',title:'Validación de foto',type:'success'});

       
    }
    rollback = ( log  ) => {
        personasService.updatePersona ( this.props.token, log.persona_id , { "image": log.old_image } )
        setupService.updateAllTags ( this.props.token , log.persona_id, 'NEW_PROFILE_IMAGE', 'V' )
        this.setState( { newProfilePhotos: this.state.newProfilePhotos.filter( (photo) => photo.persona_id !== log.persona_id ) } );
        viewActions.notification({message:'La foto cargada fue rechazada. Se volvio a la anterior.',title:'Validación de foto',type:'warning'});
    }
    clean = ( log  ) => {
        personasService.updatePersona ( this.props.token, log.persona_id , { "image": null } )
        setupService.updateAllTags ( this.props.token , log.persona_id, 'NEW_PROFILE_IMAGE', 'V' )
        this.setState( { newProfilePhotos: this.state.newProfilePhotos.filter( (photo) => photo.persona_id !== log.persona_id ) } );
        viewActions.notification({message:'La foto cargada fue rechazada. Se dejo al alumno sin foto.',title:'Validación de foto',type:'danger'});
    }


render() {
    let actions = [ 
        { label: "Validar", act: this.validate, type:'success' },
        { label: "Volver Anterior", act: this.rollback, type:'warning' } ,
        { label: "Blanquear", act: this.clean, type:'danger' } 
    ]
    
    let cols = [
        { id: 'name', title: 'Nombre', type:"STRING"}, 
        { id: 'last_name', title: 'Apellido', type:"STRING"},
        { id: 'old_image', title: 'Anterior', type:"IMG" },
        { id: 'new_image', title: 'Nueva', type:"IMG" } 
       ] ;

    return (
        <>
        <Col > 
            <Card>
                <CardBody>

                <StandardList
                    title="Nuevas fotos de perfil"
                    rows={this.state.newProfilePhotos}
                    cols={cols}
                    actions={actions}
                    />
                </CardBody>

            </Card>
        </Col>
        </>
    )
    }
}


const mapStateToProps = state => {
    return {
        view: state.view,
        school: state.config.school,
        token: state.auth.session.jwt_token,
     }
  }

  
  const mapDispatchToProps = dispatch => {
    return { 

    //   getUserDashboard: ( token ) => {
    //     dispatch( setupActions.getUserDashboard( token )) ;
    //   }
        

 
    }
  }


  export default connect(mapStateToProps, mapDispatchToProps)(NewProfileImages);

